import { getI18n } from '@/plugins/i18n'

import * as dataGridColumn from '@/composables/data-grid-column'

import { useProductService } from '@/services/product.service'
import { useWebSiteStore } from '@/stores/web-site.store'

export const useColumns = (supplierBrand = {}, keepDescription, documentRowType, supersessionId = {}, productUnitOfMeasure = {}, selectMode = false) => {
  const i18n = getI18n()
  const webSiteStore = useWebSiteStore()
  const { setTotalVatValue, setTotalNoVatValue, setPriceVatValue } = useProductService()

  const cols = []

  if (!selectMode) {
    cols.push({
      type: 'buttons',
      buttons: [{template: 'editButtonsTemplate'}],
      width: '4rem',
      visibleIndex: 0,
      fixed: false
    })
  }

  return [
    ...cols,
    dataGridColumn.useDocumentRowTypeColumn({
      preserveSupplierBrand: true,
      editCellTemplate: 'documentRowType',
      cellTemplate: 'documentRowTypeCellTemplate',
      productUnitOfMeasure: productUnitOfMeasure,
    }),
    dataGridColumn.useCostColumn({validationRules: [], visible: false, showInColumnChooser: false}),
    dataGridColumn.useCostValorizationColumn({ visible: false, showInColumnChooser: false}),
    dataGridColumn.useSupplierBrandColumn({ supplierBrand, documentRowType }),
    ...dataGridColumn.useProductColumns({ supplierBrand, keepDescription, supersessionId, preserveSupplierBrand: true, productUnitOfMeasure, dataFieldCode: 'product_ref_code' }),
    dataGridColumn.useDescriptionColumn({ validationRules: [{ type: 'required' }] }),
    dataGridColumn.useQuantityColumn(),
    dataGridColumn.usePriceColumn({
      dataField: 'product_cost',
      caption: i18n.t('common.cost'),
      validationRules: [],
      visible: false,
      showInColumnChooser: false
    }),
    dataGridColumn.usePriceColumn({ dataField: 'product_price', caption: i18n.t('common.listing'), validationRules: [], visible: false, showInColumnChooser: false }),
    dataGridColumn.usePriceColumn({ caption: i18n.t('common.unitPriceNoVat') }),
    dataGridColumn.usePriceColumn({
      dataField: 'price_vat',
      caption: i18n.t('common.unitPriceVat'),
      setCellValue: (newData, value, currentRowData) => {
        setPriceVatValue(newData, value, currentRowData)
      },
      visible: false, showInColumnChooser: false
    }),
    dataGridColumn.useDiscountCategoryColumn(),
    ...dataGridColumn.useVatTypeColumns({
      validationRules: [
        {
          type: 'custom',
          message: i18n.t('common.required'),
          reevaluate: true,
          validationCallback: (e) => {
            const type = e.data.document_row_type
            const isRequiredType = type === webSiteStore.documentRowTypesEnum.PRODUCT || type === webSiteStore.documentRowTypesEnum.FREE || type === webSiteStore.documentRowTypesEnum.LABOR || type === webSiteStore.documentRowTypesEnum.EXPENSE || type === webSiteStore.documentRowTypesEnum.SERVICE
            const hasValue = !!e.value
            return hasValue || !isRequiredType
          }
        }
      ]
    }),
    dataGridColumn.useTotalNoVatColumn({ setCellValue: (newData, value, currentRowData) => { setTotalNoVatValue(newData, value, currentRowData) } }),
    dataGridColumn.useTotalVatColumn({ setCellValue: (newData, value, currentRowData) => { setTotalVatValue(newData, value, currentRowData, currentRowData.source_includes_vat) } }),
    dataGridColumn.useChargePercentageColumn({ caption: i18n.t('common.chargePercentageAlt'), visible: false }),
    dataGridColumn.useNotesColumn(),
    dataGridColumn.useDiscountColumn(),
    dataGridColumn.useDiscount2Column({visible: false}),
    dataGridColumn.useDiscount3Column({visible: false}),
    dataGridColumn.useUrgencyDiscountColumn({visible: false}),
    dataGridColumn.useUrgencyDiscount2Column({visible: false}),
    dataGridColumn.usePaymentTypeColumn({visible: false, showInColumnChooser: false}),
    dataGridColumn.useUnitOfMeasureColumn({
      showClearButton: false,
      productUnitOfMeasure: productUnitOfMeasure,
      validationRules: [
        {
          type: 'custom',
          message: i18n.t('common.required'),
          reevaluate: true,
          validationCallback: (e) => {
            const type = e.data.document_row_type
            const isRequiredType = type === webSiteStore.documentRowTypesEnum.PRODUCT || type === webSiteStore.documentRowTypesEnum.FREE
            const hasValue = !!e.value
            return hasValue || !isRequiredType
          }
        }
      ]
    }),
    dataGridColumn.useUrgencyTypeColumn({visible: false, showInColumnChooser: false}),
    dataGridColumn.useDepositColumn({ visible: false, showInColumnChooser: false, validationRules: []}),
    dataGridColumn.useDepositColumn({
      dataField: 'garage',
      caption: i18n.t('common.garage'),
      visible: false,
      showInColumnChooser: false,
      validationRules: []}
    ),
    {
      caption: i18n.t('common.timeEquivalent'),
      dataField: 'timeEquivalent',
      editCellTemplate: 'timeEquivalentEditor',
      editorOptions: { readOnly: true },
      visible: false,
      showInColumnChooser: false,
    },
    {
      caption: i18n.t('common.includesVat'),
      dataField: 'source_includes_vat',
      dataType: 'boolean',
    },
    {
      caption: i18n.t('common.actualDuration'),
      dataField: 'actual_duration',
      dataType: 'number',
      width: '5rem',
      visible: false,
      showInColumnChooser: false
    },
    {
      caption: i18n.t('common.suggestedTime'),
      dataField: 'suggestedTime',
      editorOptions: { readOnly: true },
      visible: false,
      showInColumnChooser: false,
    },
    {
      caption: i18n.t('common.operationCode'),
      dataField: 'operationCode',
      editorOptions: { readOnly: true },
      visible: false,
      showInColumnChooser: false,
    },
    {
      caption: i18n.t('common.recognizedTime'),
      dataField: 'recognizedTime',
      editorOptions: { readOnly: true },
      visible: false,
      showInColumnChooser: false,
    },
  ]
}
